import { render, staticRenderFns } from "./RelatorioFaturamentoModal.vue?vue&type=template&id=3ebbaf2a&scoped=true"
import script from "./RelatorioFaturamentoModal.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebbaf2a",
  null
  
)

export default component.exports